const NodeNames = {
  br: 'BR',
  comment: '#comment',
  text: '#text',
};

function trimNodes(nodes: ChildNode[], direction: 'start' | 'end'): void {
  nodes = direction === 'start' ? nodes : nodes.reverse();

  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];

    if (node.childNodes.length === 1 && node.childNodes.item(0).nodeName === NodeNames.br) {
      node.remove();
    } else if (!node.textContent.trim()) {
      node.remove();
    } else if (node.nodeName === NodeNames.comment) {
      node.remove();
    } else if (node.nodeName === NodeNames.text) {
      const trimmedTextValue = direction === 'start' ? node.nodeValue.trimStart() : node.nodeValue.trimEnd();

      if (trimmedTextValue) {
        (node as HTMLElement).textContent = trimmedTextValue;
        break;
      } else {
        node.remove();
      }
    } else {
      break;
    }
  }
}

/** Removes white spaces and empty elements at the start and at the end of HTML */
export function trimHtml(htmlString: string): string {
  const newElement = document.createElement('div');
  newElement.innerHTML = htmlString;
  const nodesArray = Array.from(newElement.childNodes);

  trimNodes(nodesArray, 'start'); // trim start of nodes
  trimNodes(nodesArray, 'end'); // trim end of nodes

  nodesArray.forEach((node) => {
    if (node.nodeName === NodeNames.comment) {
      newElement.removeChild(node);
    }
  });

  return newElement.innerHTML;
}
